/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_AcceptInputs */

const en_confirm_accept = /** @type {(inputs: Confirm_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const he_confirm_accept = /** @type {(inputs: Confirm_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אישור`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Confirm_AcceptInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_accept = /** @type {((inputs?: Confirm_AcceptInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_AcceptInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_accept(inputs)
	return he_confirm_accept(inputs)
});